import type { SymbolDefinition } from "../types.ts";

export const motorProtector: SymbolDefinition = {
  id: "ep-motor-protector",
  familyKey: "motor_protector",
  deviceKind: "motor_protector",
  version: "0.1.0",
  label: { sv: "Motorskyddsbrytare", en: "Motor protector" },
  description: { sv: "Termisk motorskyddsbrytare.", en: "Thermal motor protection breaker." },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <rect x="6" y="14" width="36" height="20" rx="2"/>
      <line x1="8" y1="4" x2="8" y2="14"/>
      <line x1="24" y1="4" x2="24" y2="14"/>
      <line x1="40" y1="4" x2="40" y2="14"/>
      <line x1="8" y1="34" x2="8" y2="44"/>
      <line x1="24" y1="34" x2="24" y2="44"/>
      <line x1="40" y1="34" x2="40" y2="44"/>
      <path d="M 14 20 L 18 26 L 22 20 L 26 26 L 30 20 L 34 26" />
    </g>
  `,
  terminals: [
    { id: "L1-in", kind: "phase", label: "L1", position: "top", offset: 0.167 },
    { id: "L2-in", kind: "phase", label: "L2", position: "top", offset: 0.5 },
    { id: "L3-in", kind: "phase", label: "L3", position: "top", offset: 0.833 },
    { id: "T1-out", kind: "phase", label: "T1", position: "bottom", offset: 0.167 },
    { id: "T2-out", kind: "phase", label: "T2", position: "bottom", offset: 0.5 },
    { id: "T3-out", kind: "phase", label: "T3", position: "bottom", offset: 0.833 },
  ],
  designationPrefix: "Q",
  searchKeywords: ["motorskydd", "motorskyddsbrytare", "thermal"],
};
